import { Stack, Typography } from "@mui/material";
import { useContext } from "react";

import Context from "../context";
import ProductItem from "./ProductItem";
import { useGetClientDetailData } from "./useGetClientDetailData";

export default function EditDialogContent() {
	const { state } = useContext(Context);
	const { data, onChangeValue } = useGetClientDetailData();

	return (
		<Stack sx={{ p: 3 }}>
			<Typography variant='subtitle1'>{state.client?.name}</Typography>
			<Typography variant='subtitle2' sx={{ mt: 2, pb: 1 }}>
				{"Tiene contratado:"}
			</Typography>
			<ProductItem
				onChange={() => onChangeValue("TRANSACTIONS")}
				title='Transacciones'
				checked={!!data?.find((i) => i === "TRANSACTIONS")}
			/>
			<ProductItem
				onChange={() => onChangeValue("ACTIVE_POSITIONS")}
				title='Posiciones'
				checked={!!data?.find((i) => i === "ACTIVE_POSITIONS")}
			/>
			<ProductItem
				onChange={() => onChangeValue("ASSETS_TRANSFER")}
				title='Traspasos'
				checked={!!data?.find((i) => i === "ASSETS_TRANSFER")}
			/>
		</Stack>
	);
}
